/* sv-header.js — Drawer accordion (capture-phase intercept)
 *
 * WHY THIS APPROACH:
 * Dawn's MenuDrawer.bindEvents() registers an 'onSummaryClick' listener
 * directly on each <summary> element (bubble phase). We cannot easily
 * remove or override those registered listeners. Instead, we register a
 * CAPTURE-phase listener on document — capture listeners run before any
 * bubble-phase listener on any descendant, so ours fires first.
 *
 * For sub-menu summaries inside <header-drawer> we:
 *   1. Call stopImmediatePropagation() → Dawn's listener never fires.
 *   2. Call preventDefault()           → native <details> toggle is blocked.
 *   3. Manually toggle the [open] attribute ourselves.
 *
 * Our CSS in sv-overrides.css then handles visibility:
 *   details[open] > .menu-drawer__submenu { display: block !important; }
 *
 * The main hamburger <summary> (which opens/closes the whole drawer) is
 * excluded so Dawn's open/close animation still works normally.
 */

(function () {
  document.addEventListener('click', function (event) {
    /* Only care about clicks that land on (or inside) a <summary> */
    var summary = event.target.closest('summary');
    if (!summary) return;

    /* Must be inside a <header-drawer> */
    var drawer = summary.closest('header-drawer');
    if (!drawer) return;

    /* The outer <details> is the hamburger toggle — let Dawn handle it */
    var outerDetails = drawer.querySelector('#Details-menu-drawer-container');
    var details = summary.parentElement;
    if (!details || details === outerDetails) return;

    /* ── Take full control of this sub-menu click ── */
    event.stopImmediatePropagation(); /* Dawn's listener never fires */
    event.preventDefault();           /* native <details> toggle blocked */

    if (details.hasAttribute('open')) {
      /* Close */
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    } else {
      /* Open — optionally close any sibling open details (single-open accordion) */
      var parentList = details.parentElement && details.parentElement.parentElement;
      if (parentList) {
        parentList.querySelectorAll(':scope > li > details[open]').forEach(function (sib) {
          if (sib !== details) {
            sib.removeAttribute('open');
            var sibSummary = sib.querySelector('summary');
            if (sibSummary) sibSummary.setAttribute('aria-expanded', 'false');
          }
        });
      }
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    }
  }, true /* capture phase */);
}());
